import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q22 = ({ history }) => {
  const { t } = useTranslation();
  const Q22Options = useMemo(
    () => [
      {
        id: 0,
        name: t('real-time-location'),
        value: 'real_time_location',
      },
      {
        id: 1,
        name: t('location-history'),
        value: 'location_history',
      },
      {
        id: 2,
        name: t('place_alerts'),
        value: 'place_alerts',
      },
      {
        id: 3,
        name: t('sos-notifications'),
        value: 'sos_notifications',
      },
      {
        id: 4,
        name: t('car-crash-alerts'),
        value: 'car_crash_alerts',
      },
      {
        id: 5,
        name: t('all_the_above'),
        value: 'all_the_above',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question22')}
      options={Q22Options}
      nextUrl="q23"
      screenName="q22"
      multiple
    />
  );
};

export default Q22;
